/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Logout_ForceInputs */

const en_us2_profile_editors_logout_force = /** @type {(inputs: Profile_Editors_Logout_ForceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out anyway`)
};

const pt_br2_profile_editors_logout_force = /** @type {(inputs: Profile_Editors_Logout_ForceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair mesmo assim`)
};

const es_419_profile_editors_logout_force = /** @type {(inputs: Profile_Editors_Logout_ForceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar sesión igual`)
};

const pt_pt2_profile_editors_logout_force = /** @type {(inputs: Profile_Editors_Logout_ForceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminar sessão mesmo assim`)
};

const fr_fr2_profile_editors_logout_force = /** @type {(inputs: Profile_Editors_Logout_ForceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se déconnecter quand même`)
};

const de_de2_profile_editors_logout_force = /** @type {(inputs: Profile_Editors_Logout_ForceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trotzdem abmelden`)
};

const it_it2_profile_editors_logout_force = /** @type {(inputs: Profile_Editors_Logout_ForceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esci comunque`)
};

/**
* | output |
* | --- |
* | "Sign out anyway" |
*
* @param {Profile_Editors_Logout_ForceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_logout_force = /** @type {((inputs?: Profile_Editors_Logout_ForceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Logout_ForceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_logout_force(inputs)
	if (locale === "es-419") return es_419_profile_editors_logout_force(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_logout_force(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_logout_force(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_logout_force(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_logout_force(inputs)
	return en_us2_profile_editors_logout_force(inputs)
});
export { profile_editors_logout_force as "profile-editors.logout_force" }